module.exports = function(req) {
  return {
    error_code: 123,
    data: 
    {
      "unit_id": 3,
      "user_name":"Harry",
      "unit_name":"unit 1 学习文具",
      "key_word": [
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/8a0ea4fa-6f6b-41e3-8a48-29ae4c1f1b0e.mp3",
          "id": 11997,
          "id_cipher": "F10C75510A13050F214AF38024F9599C",
          "uuid": "a6b67b5090ad497e4f6fff41e5c6209e",
          "word_name": "after",
          "word_picture_link": "http://s.kg.51talkjr.com/4c57ceb5-29cb-4b8a-8e2b-7f5eedb2c2cc.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/3f762ad5-b27d-432c-a648-7dd1f7b86f09.mp3",
          "id": 12124,
          "id_cipher": "8E05ABD731A0F95C601CCE4CBAF449B6",
          "uuid": "1cea9068891580157eb5858ef0994664",
          "word_name": "before",
          "word_picture_link": "http://s.kg.51talkjr.com/3836c61a-6d40-44a2-9f7b-b878f652a27b.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/d89b63bc-c837-43ed-918e-0f6fed4e3a9b.mp3",
          "id": 12720,
          "id_cipher": "B977C56A479D37A5B23A2097F2D03560",
          "uuid": "e18e0a19f5758941333b6938de6543a5",
          "word_name": "Friday",
          "word_picture_link": "http://s.kg.51talkjr.com/d283dd00-64d4-4acb-8c6f-f3c709d4323b.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/8f0194b6-325e-474f-bbe8-314f846b623e.mp3",
          "id": 13157,
          "id_cipher": "661C5D0CBCDBAFEE80880C3BD70C3F83",
          "uuid": "7b91284dd39b0f47b3eb9e5b3b86a299",
          "word_name": "Monday",
          "word_picture_link": "http://s.kg.51talkjr.com/e2b19b63-430e-4a13-ab6c-08a8bdfabf21.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/e0ccfe1c-ba7f-45a6-be73-72109c080f27.mp3",
          "id": 13536,
          "id_cipher": "66F02468596123DCAB7C893B8B65B403",
          "uuid": "d6b9b05219c71fe061e2347c2ee01399",
          "word_name": "Saturday",
          "word_picture_link": "http://s.kg.51talkjr.com/e24a9ce2-b617-4008-b8be-b2a0a29fc67d.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/f0d25cc9-e57a-49c0-89b1-cb73c7f7350a.mp3",
          "id": 13790,
          "id_cipher": "095D8A2D9E161D1D457B97EF78240BEC",
          "uuid": "4af6de15850eb98e4ebfb7a4af4abeaa",
          "word_name": "Sunday",
          "word_picture_link": "http://s.kg.51talkjr.com/9d04f21d-4733-4bcf-a575-a47d1bbc4b97.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/bbf5acd4-2157-4499-a074-f1376c5113cf.mp3",
          "id": 13885,
          "id_cipher": "03F3B8C60A3E6E30B9641977C77C8854",
          "uuid": "cc52cc6ab550d564333faa1a99570b0f",
          "word_name": "Thursday",
          "word_picture_link": "http://s.kg.51talkjr.com/fb8b4f60-7e45-431c-a376-528ab7941442.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/a757bc13-b605-42f4-9a84-8885e274d415.mp3",
          "id": 13946,
          "id_cipher": "B4864DF836DCE185B695768B89286130",
          "uuid": "0867275c7a725d8f29e9a072555d19ab",
          "word_name": "Tuesday",
          "word_picture_link": "http://s.kg.51talkjr.com/30e1b314-6291-4add-820d-d4c7786f2f32.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/d08a29bf-8968-43c5-96a4-9bc6bc0101b8.mp3",
          "id": 14035,
          "id_cipher": "01CBE29D13D11B8E0C8ECB1ED5BE2A8A",
          "uuid": "c2904ff35f315c6a86b84f5774cb38c5",
          "word_name": "Wednesday",
          "word_picture_link": "http://s.kg.51talkjr.com/f343c6d4-69f6-4f82-b49d-34a0e2c6310f.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/0af54078-26bd-4038-a961-b81d8e730c77.mp3",
          "id": 14037,
          "id_cipher": "E3762B7036AAEBB55B95E89E24825245",
          "uuid": "1803f439abcd49858bcb9b35532acda3",
          "word_name": "week",
          "word_picture_link": "http://s.kg.51talkjr.com/e0922efa-b439-4b99-b67e-5b5772b1d60e.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/c1376fee-3c64-40ac-af25-e6c8cc2b7a55.mp3",
          "id": 14039,
          "id_cipher": "B2559ECBBB5B61A8AC37148267228C0B",
          "uuid": "22df5159f1b142514970e5e52eabda70",
          "word_name": "weekend",
          "word_picture_link": "http://s.kg.51talkjr.com/75e67db9-4b81-40d3-aaf3-0001e227af33.jpg",
          "word_picture_link_levelk": ""
        },
        {
          "cej_ph_en": "http://s.kg.51talkjr.com/7e3105c7-40a0-49f2-a01f-ed9cbf3e7175.mp3",
          "id": 14274,
          "id_cipher": "07672FA3A47617CCB7EE5E8F4BB30E10",
          "uuid": "8814bd800e2dbbcc661aed6627d9a877",
          "word_name": "plan",
          "word_picture_link": "http://s.kg.51talkjr.com/40048087-2b53-4ac9-895b-fb77d4ee900a.jpg",
          "word_picture_link_levelk": ""
        }
      ],
      "sentence": [
        {
          "id": 286,
          "id_cipher": "6396C8B6F38960C8C940D24E97046415",
          "sentence_en": "What do you do on Mondays?",
          "sentence_en_answer": "I usually play soccer on Mondays!",
          "sentence_en_answer_mp3": "http://s.kg.51talkjr.com/3fd4454e-6924-4694-a68f-d0a363984ac6.mp3",
          "sentence_en_mp3": "http://s.kg.51talkjr.com/630b8ebe-3e12-4fe2-b975-6caeaa944560.mp3",
          "uuid": "8d982ca83db34a83df35ddf161fa4b9e"
        },
        {
          "id": 287,
          "id_cipher": "D5CCE7E1FB75938EBA2F5395FBEBD993",
          "sentence_en": "I will go to piano class after school.",
          "sentence_en_answer": null,
          "sentence_en_answer_mp3": null,
          "sentence_en_mp3": "http://s.kg.51talkjr.com/4f017751-6923-48b8-9795-f9e1f8fff68a.mp3",
          "uuid": "d8319ff3316ea4f3311bc862333e8e37"
        },
        {
          "id": 288,
          "id_cipher": "61ED3904D29677BAA84251EB9FC70A1E",
          "sentence_en": "I usually play the piano on Wednesday.",
          "sentence_en_answer": null,
          "sentence_en_answer_mp3": null,
          "sentence_en_mp3": "http://s.kg.51talkjr.com/b614b7a7-6d3d-427a-866f-908eed4c1863.mp3",
          "uuid": "3b54af369bc447ca521597366d98007f"
        },
        {
          "id": 289,
          "id_cipher": "8DB2A9ED79ADFB8CA1D781DE04EF4A56",
          "sentence_en": "When do you play the guitar?",
          "sentence_en_answer": "We usually play during the week, on Monday, Wednesday, and Thursday.",
          "sentence_en_answer_mp3": "http://s.kg.51talkjr.com/3ef424ff-82cf-4dbc-9ca9-877382316ca3.mp3",
          "sentence_en_mp3": "http://s.kg.51talkjr.com/3fb27324-efd9-4af4-890a-5aa0c6e99d2e.mp3",
          "uuid": "7187344b5e16ead5d3e60d68b8e6b2a8"
        },
        {
          "id": 290,
          "id_cipher": "9CA1F58E177D35767597742F262041FD",
          "sentence_en": "When is your birthday party?",
          "sentence_en_answer": "My birthday party will be on Saturday night at the ice rink.",
          "sentence_en_answer_mp3": "http://s.kg.51talkjr.com/0782d920-e92d-44e9-befe-36e402eb6460.mp3",
          "sentence_en_mp3": "http://s.kg.51talkjr.com/ce23a809-c2f2-4c9a-af5b-702e34198d2b.mp3",
          "uuid": "7e66342239593c8a8fa0dff50ec29903"
        },
        {
          "id": 291,
          "id_cipher": "A54D2CCCD491CBA9525A0B6B0B900430",
          "sentence_en": "Do you have plans this weekend?",
          "sentence_en_answer": "I will go to my little sister's birthday party.",
          "sentence_en_answer_mp3": "http://s.kg.51talkjr.com/76a989ef-16da-45ad-b929-0f3ea41959b4.mp3",
          "sentence_en_mp3": "http://s.kg.51talkjr.com/ebe68a00-d7c5-4851-84f4-325f9b647b72.mp3",
          "uuid": "c5cb0aae0df675728598e6bc911477c6"
        },
        {
          "id": 292,
          "id_cipher": "297687B7C06303EE93E3F4EC1E12DBD4",
          "sentence_en": "What will you do tonight?",
          "sentence_en_answer": "Cindy and I will go to the movies! We will eat pizza before the movies.",
          "sentence_en_answer_mp3": "http://s.kg.51talkjr.com/4b71b462-e256-4f93-9888-626cc57d647d.mp3",
          "sentence_en_mp3": "http://s.kg.51talkjr.com/37889e86-2983-48d9-9a07-875efaac7962.mp3",
          "uuid": "b2cfec113190d76c4d0be87579da545b"
        }
      ],
      "grammar_level": [
        {
          "grammar_level": "一般现在时",
          "grammar_level_en": "Simple present tense",
          "id": 16,
          "id_cipher": "5CAFBE78319435DCFE1B5A09A339A9E4",
          "uuid": "2ec69376772d6b0e7238389f81294bec"
        },
        {
          "grammar_level": "特殊疑问句",
          "grammar_level_en": "special question",
          "id": 53,
          "id_cipher": "D9D991C1A13A286181A3525907227A23",
          "uuid": "42fd1a8c8efd28ba17f1b8c180f8c7c5"
        },
        {
          "grammar_level": "基数词",
          "grammar_level_en": "Cardinal numbers",
          "id": 73,
          "id_cipher": "5A9D078150792F3D67F12073A09E6568",
          "uuid": "6b6d86215508482cbe08b132e064806b"
        },
        {
          "grammar_level": "指示代词(单数)",
          "grammar_level_en": "demonstrative pronoun",
          "id": 82,
          "id_cipher": "BFA9E6ABE265CF8F2AEB28344888F519",
          "uuid": "87430ee778a135afdbc9cbede48c2fcb"
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/template/mock/unit.js